import axios from 'axios';
import _ from 'underscore';

export function GetContribuyentes(nombre, callback) {
  axios({
    method: 'get',
    url: '/api/Contribuyente/Nombre/' + nombre,
    config: {skipError:true}
  }).then((obj) => {
    callback(obj);
  });
}

export function GetFoliosTipoDocumento(tipo_documento, callback) {
  axios({
    method: 'get',
    url: '/api/DTE/Folios/TipoDocumento/' + tipo_documento
  }).then((obj) => {
    callback(obj);
  })
}

export function GetCodigosReferencia(callback) {
  //TODO: Pasar a BD
  var codigosReferencia = [
    { CodReferencia: 1, NombreCodReferencia: "Anula Documento de Referencia" },
    { CodReferencia: 2, NombreCodReferencia: "Corrige Texto Documento de Referencia"  },
    { CodReferencia: 3, NombreCodReferencia: "Corrige montos"  }
  ]
  callback(codigosReferencia);
}

export function CrearDTE(dteData, isXML, isBorrador, callback, errorCallback) {
  axios({
    method: 'post',
    url: '/api/DTE/Crear' + (isBorrador ? "/borrador" : ""),
    headers: {
      "Content-Type": isXML ? "text/xml" : "application/json"
    },
    data: dteData
  }).then((obj) => {
    callback(obj);
  }).catch((e)=> {
    errorCallback(e);
  })
}